import { ICampaign } from '@/types';
import { getUrl } from '@/utils/api';

function useCampaigns(filter?: string) {
  let url = `v1/campaigns`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as ICampaign[],
  };
}

export default useCampaigns;
